import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './Layout.module.scss';

import Container from './components/Container/Container';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Title from './components/Title/Title';

export class Layout extends Component {
  static propTypes = {
    className: PropTypes.string,
    overflowUnset: PropTypes.bool,
    children: PropTypes.node.isRequired
  };

  static defaultProps = {
    className: '',
    overflowUnset: false
  };

  render() {
    const { className, overflowUnset } = this.props;

    return (
      <div className={styles.Layout}>
        <Header />
        <div
          className={`${className} ${styles.Wrapper}`}
          style={overflowUnset ? { overflow: 'unset' } : {}}
        >
          {this.props.children}
        </div>
        <Footer />
      </div>
    );
  }
}

export { Container };
export { Title };



// WEBPACK FOOTER //
// ./src/common/components/Layout/Layout.js